import React, { FunctionComponent, ReactNode } from 'react'
import { Host } from 'react-native-portalize'

export const HostWrapper: FunctionComponent<{ children: ReactNode | ReactNode[] }> = ({ children }) => {
  return <Host>{children}</Host>
}
